import { FC } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import css from "./index.module.css";
import { toast } from "sonner";
import useUserData from "@hooks/useUserData";

interface CartProduct {
  id: number;
  prodID?: number;
  title: string;
  price: number;
  image: string;
  count?: number;
  buttons?: boolean;
  width?: string;
  fav?: boolean;
  unit: "ШТ" | "КГ";
  unitCart: "ШТ" | "КГ" | "КОРОБ";
  quantity: number;
}

const CartProduct: FC<CartProduct> = ({
  id,
  prodID,
  title,
  price,
  image,
  count,
  buttons,
  width,
  fav,
  unit,
  unitCart,
}) => {
  const { refreshCartData } = useUserData();
  const navigate = useNavigate();

  const goProduct = () => {
    navigate(`/webapp/product/${prodID}`);
  };

  const manageProduct = (type: number, id: number) => {
    axios
      .post(
        `${import.meta.env.VITE_API_URL}/user/cart/${
          type === 0 ? "add" : "delete"
        }`,
        { cartId: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )
      .then((_) => {
        toast.success(type === 0 ? "Добавили продукт" : "Удалили продукт");
        refreshCartData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteAll = (id: number) => {
    axios
      .post(
        `${import.meta.env.VITE_API_URL}/user/cart/deleteall`,
        { cartId: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )
      .then((_) => {
        toast.success("Товар удалён из корзины");
        refreshCartData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const formatNumber = (num: number) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  return (
    <div
      className={`${css.cartProduct}`}
      style={
        fav === true ? { border: "none", background: "none", padding: 0 } : {}
      }
    >
      <div className={css.leftSide}>
        <div className={css.img} onClick={goProduct}>
          <div
            className={css.image}
            style={{
              backgroundImage: `url(${
                image ? image : "/assets/images/noImage.jpg"
              })`,
            }}
          />
        </div>

        <div className={css.textInfo} onClick={goProduct}>
          <h2 style={{ width: width }}>{title}</h2>
          <a>
            {formatNumber(price)} ₽ / {unit || "ШТ"}
          </a>
        </div>
      </div>

      <div>
        {buttons === true && (
          <div className={css.countContainer} style={{ alignItems: "center", justifyContent: "space-between" }}>
            <div className={css.countContainer} style={{ flex: 1, justifyContent: "center" }}>
              <div className={css.plus} onClick={() => manageProduct(0, id)}>
                <i className="fi fi-rr-plus"></i>
              </div>
              <div className={css.count}>
                {count} {unitCart}
              </div>
              <div className={css.minus} onClick={() => manageProduct(1, id)}>
                <i className="fi fi-rr-minus"></i>
              </div>
            </div>
            <div
              className={css.minus}
              onClick={() => deleteAll(id)}
              title="Удалить все"
              style={{ border: "none" }}
            >
              <i className="fi fi-rr-trash"></i>
            </div>
          </div>
        )}
        {!buttons && count && (
          <a style={{ textWrap: "nowrap", fontWeight: 600 }}>
            ЗАКАЗАНО: {count} {unitCart || "ШТ"}.
          </a>
        )}
      </div>
    </div>
  );
};

export default CartProduct;
